var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Exit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17.163,
    viewBox: "0 0 21 17.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_input_24px",
    d: "M20.091,3.01H2.909A1.915,1.915,0,0,0,1,4.919V8.728H2.909V4.9H20.091V18.292H2.909V14.455H1v3.828a1.9,1.9,0,0,0,1.909,1.89H20.091A1.9,1.9,0,0,0,22,18.283V4.919A1.909,1.909,0,0,0,20.091,3.01Zm-9.545,12.4,3.818-3.818L10.545,7.773v2.864H1v1.909h9.545Z",
    transform: "translate(-1 -3.01)",
    fill: "#666e78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.a13134fe0deb7a19e97796aa7769b09a.svg";
export { ForwardRef as ReactComponent };